// extracted by mini-css-extract-plugin
export default {"error-message":"ErrorMessage_error-message__Gywuo","layout-error-message":"ErrorMessage_layout-error-message__WlWGH"};